import { useMentorPlus } from 'app/features/MentorPlus/hooks';
import { lazyLoad } from 'utils/loadable';

const PDPDrawer = lazyLoad(
  () => import(/* webpackChunkName: 'PDPDrawer' */ './PDPAuth'),
  m => m.default,
);

export default function PDPDrawerLazy() {
  const { pdpDrawerState } = useMentorPlus();
  if (!pdpDrawerState.show) return <></>;
  return <PDPDrawer />;
}
